import { ref, type Ref } from 'vue';

export interface ToastOptions {
  title: string;
  message: string;
  duration?: number;
  type?: 'success' | 'error' | 'info';
}

export type ToastState = ToastOptions & {
  duration: number;
  type: 'success' | 'error' | 'info';
};

/** Shared toast state so composables (e.g. rebet) and App.vue show the same message. */
const toast: Ref<ToastState | null> = ref(null);
let hideTimer: ReturnType<typeof setTimeout> | null = null;

export function useToast() {
  const showToast = (options: ToastOptions) => {
    const duration = options.duration ?? 5000;
    const type = options.type ?? 'info';

    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }

    toast.value = {
      title: options.title,
      message: options.message,
      duration,
      type,
    };

    hideTimer = setTimeout(() => {
      toast.value = null;
      hideTimer = null;
    }, duration);
  };

  return {
    toast,
    showToast,
  };
}
